export const excludedErrandButtonRules = [
    'disableWhenUnconnectedAndAllowUnconnectedSaveIsFalse'
];
